import React, { useState, useEffect } from "react";
import HPostCard from "../../../hcomponents/HPostCard";
import HMemberCard from "../../../hcomponents/HMemberCard";
import HBusinessCard from "../../../hcomponents/HBusinessCard";
import HActionButton from "../../../hcomponents/HActionButton";
import HSectionHeader from "../../../hcomponents/HSectionHeader";
import HHeader from "../../../hcomponents/HHeader";
import { Constants } from "../../../utils/constants";
import HPageContainer from "../../../hcomponents/HPageContainer";
import HCreateEventModal from "../../../hcomponents/HCreateEventModal";
import HCreateAnnouncementModal from "../../../hcomponents/HCreateAnnouncementModal";
import HEditAnnouncementModal from "../../../hcomponents/HEditAnnouncementModal";
import { Plus, Search, Calendar, Trash2, Megaphone, Edit } from "lucide-react";

const HostCommunity = () => {
  const [activeTab, setActiveTab] = useState("feed"); // 'feed', 'community', or 'announcements' for mobile view
  const [showEventModal, setShowEventModal] = useState(false);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [showEditAnnouncementModal, setShowEditAnnouncementModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [announcementToDelete, setAnnouncementToDelete] = useState(null);
  const [announcementToEdit, setAnnouncementToEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [announcements, setAnnouncements] = useState([]);
  const [isLoadingAnnouncements, setIsLoadingAnnouncements] = useState(true);

  // Load announcements data
  useEffect(() => {
    setTimeout(() => {
      const dummyAnnouncements = [
        {
          id: 1,
          title: "Office Closure Notice",
          message:
            "Our offices will be closed on Monday for the holiday. Please make alternative arrangements if you have meetings scheduled.",
          createdAt: new Date(2023, 11, 15),
          datetimeToSend: new Date(2023, 11, 20),
          roles: ["ROLE_ADMINISTRATOR", "ROLE_USER"],
          image:
            "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
        },
        {
          id: 2,
          title: "New Workspace Launch",
          message: "We are excited to announce the launch of our new premium workspace in downtown.",
          createdAt: new Date(2023, 11, 10),
          datetimeToSend: new Date(2023, 11, 25),
          roles: ["ROLE_USER"],
          image:
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
        },
        {
          id: 3,
          title: "System Maintenance",
          message: "The booking system will be under maintenance this Saturday from 10 PM to 2 AM.",
          createdAt: new Date(2023, 11, 5),
          datetimeToSend: new Date(2023, 11, 18),
          roles: ["ROLE_ADMINISTRATOR", "ROLE_USER", "ROLE_HOST"],
          image: null,
        },
      ];
      setAnnouncements(dummyAnnouncements);
      setIsLoadingAnnouncements(false);
    }, 1000);
  }, []);

  const posts = [
    {
      id: 1,
      type: "Post",
      title: "Discounted rates on co-working space 30% Off",
      description: "Discounted rates on co-working space 30% Off",
      image:
        "https://images.unsplash.com/photo-1747645294647-512969fd2d23?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      avatars: [
        {
          src: "https://randomuser.me/api/portraits/women/44.jpg",
          alt: "User 1",
        },
        {
          src: "https://randomuser.me/api/portraits/men/46.jpg",
          alt: "User 2",
        },
      ],
      date: "12 Jul 2022",
      comments: 2,
      files: 0,
    },
    {
      id: 2,
      type: "Post",
      title: "Meeting rooms 30% Off",
      description: "Discounted rates on Meeting rooms 30% Off",
      image:
        "https://images.unsplash.com/photo-1747645294647-512969fd2d23?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      avatars: [
        {
          src: "https://randomuser.me/api/portraits/women/44.jpg",
          alt: "User 1",
        },
        {
          src: "https://randomuser.me/api/portraits/men/46.jpg",
          alt: "User 2",
        },
      ],
      date: "12 Jul 2022",
      comments: 2,
      files: 0,
    },
    {
      id: 3,
      type: "Event",
      title: "Ecommerce Dashboard",
      description: "Ecommerce Dashboard to monitor store sale and inventory.",
      avatars: [
        {
          src: "https://randomuser.me/api/portraits/women/44.jpg",
          alt: "User 1",
        },
        {
          src: "https://randomuser.me/api/portraits/men/46.jpg",
          alt: "User 2",
        },
      ],
      date: "12 Jul 2022",
      comments: 2,
      files: 0,
    },
    {
      id: 4,
      type: "Event",
      title: "Ecommerce Dashboard",
      description: "Ecommerce Dashboard to monitor store sale and inventory.",
      avatars: [
        {
          src: "https://randomuser.me/api/portraits/women/44.jpg",
          alt: "User 1",
        },
        {
          src: "https://randomuser.me/api/portraits/men/46.jpg",
          alt: "User 2",
        },
      ],
      date: "12 Jul 2022",
      comments: 2,
      files: 0,
    },
  ];

  const members = [
    {
      id: 1,
      name: "Blessy",
      organization: "Horizons",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      id: 2,
      name: "Partha",
      organization: "Kofisi",
      avatar: "https://randomuser.me/api/portraits/men/46.jpg",
    },
    {
      id: 3,
      name: "Vicky",
      organization: "Ikigai",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
    },
    {
      id: 4,
      name: "Sara",
      organization: "Lorem Ipsum",
      avatar: "https://randomuser.me/api/portraits/women/90.jpg",
    },
  ];

  const businesses = [
    {
      id: 1,
      name: "Horizons",
      description: "Lorem Ipsum",
      logo: "https://logo.clearbit.com/horizons.com",
    },
    {
      id: 2,
      name: "Kofisi",
      description: "Lorem Ipsum",
      logo: "https://logo.clearbit.com/kofisi.com",
    },
    {
      id: 3,
      name: "Ikigai",
      description: "Lorem Ipsum",
      logo: "https://randomuser.me/api/portraits/women/68.jpg",
    },
    {
      id: 4,
      name: "Sara",
      description: "Lorem Ipsum",
      logo: "https://randomuser.me/api/portraits/women/90.jpg",
    },
  ];

  // Announcement functions
  const formatDate = date => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateTime = date => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleAddAnnouncement = newAnnouncementData => {
    const newId = announcements.length > 0 ? Math.max(...announcements.map(a => a.id)) + 1 : 1;
    const announcement = {
      id: newId,
      title: newAnnouncementData.title,
      message: newAnnouncementData.message,
      createdAt: new Date(),
      datetimeToSend: new Date(),
      roles: [],
      image: null,
    };
    setAnnouncements([announcement, ...announcements]);
  };

  const handleEditAnnouncement = announcement => {
    setAnnouncementToEdit(announcement);
    setShowEditAnnouncementModal(true);
  };

  const handleDeleteAnnouncement = announcement => {
    setAnnouncementToDelete(announcement);
    setShowConfirmDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (announcementToDelete) {
      setAnnouncements(announcements.filter(a => a.id !== announcementToDelete.id));
      setAnnouncementToDelete(null);
      setShowConfirmDeleteModal(false);
    }
  };

  const handleEditSave = updatedAnnouncement => {
    setAnnouncements(prevAnnouncements =>
      prevAnnouncements.map(announcement =>
        announcement.id === updatedAnnouncement.id ? { ...announcement, ...updatedAnnouncement } : announcement
      )
    );
    setShowEditAnnouncementModal(false);
    setAnnouncementToEdit(null);
  };

  const filteredAnnouncements = announcements.filter(
    announcement =>
      announcement.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      announcement.message.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const activeTabStyle = {
    color: Constants.HOST_EXPERIENCE_BASE_COLOR,
    borderBottom: `2px solid ${Constants.HOST_EXPERIENCE_BASE_COLOR}`,
  };

  const HeaderButtons = () => (
    <div className="flex gap-3 md:gap-4">
      <HActionButton
        label="Add Event"
        icon={<Plus className="h-4 w-4" />}
        variant="primary"
        onClick={() => setShowEventModal(true)}
      />
      <HActionButton
        label="Add Announcement"
        icon={<Plus className="h-4 w-4" />}
        variant="primary"
        onClick={() => setShowAnnouncementModal(true)}
      />
    </div>
  );

  const ShimmerLoading = () => (
    <div className="space-y-3">
      {[1, 2, 3].map(item => (
        <div
          key={item}
          className="bg-white rounded-xl shadow-sm p-3 border border-gray-100 w-full flex items-start animate-pulse"
        >
          <div className="w-16 h-16 bg-gray-200 rounded-md mr-3 flex-shrink-0"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-full mb-1"></div>
            <div className="h-3 bg-gray-200 rounded w-full mb-1"></div>
            <div className="h-3 bg-gray-200 rounded w-4/5"></div>
            <div className="flex items-center justify-between mt-2">
              <div className="h-3 bg-gray-200 rounded w-1/4"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <HPageContainer>
      <HHeader rightButton={<HeaderButtons />} />

      <div className="flex-1 overflow-auto p-3 sm:p-4 md:p-6 lg:p-8">
        <div className="mx-auto max-w-7xl">
          {/* Mobile Tabs - Updated with announcements */}
          <div className="flex border-b border-gray-200 mb-4 md:hidden">
            <button
              className={`flex-1 py-2 px-4 text-center font-medium ${activeTab === "feed" ? "" : "text-gray-500"}`}
              onClick={() => setActiveTab("feed")}
              style={activeTab === "feed" ? activeTabStyle : {}}
            >
              Feed
            </button>
            <button
              className={`flex-1 py-2 px-4 text-center font-medium ${activeTab === "community" ? "" : "text-gray-500"}`}
              onClick={() => setActiveTab("community")}
              style={activeTab === "community" ? activeTabStyle : {}}
            >
              Community
            </button>
            <button
              className={`flex-1 py-2 px-4 text-center font-medium ${activeTab === "announcements" ? "" : "text-gray-500"}`}
              onClick={() => setActiveTab("announcements")}
              style={activeTab === "announcements" ? activeTabStyle : {}}
            >
              Announcements
            </button>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
            {/* Feed Section */}
            <div className={`lg:col-span-2 ${activeTab === "feed" ? "block" : "hidden lg:block"}`}>
              <div className="max-h-[calc(100vh-200px)] overflow-y-auto pr-0 md:pr-4">
                <div className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
                  {posts.map(post => (
                    <HPostCard
                      key={post.id}
                      type={post.type}
                      title={post.title}
                      description={post.description}
                      image={post.image}
                      avatars={post.avatars}
                      date={post.date}
                      comments={post.comments}
                      files={post.files}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className={`space-y-6 md:space-y-8 ${activeTab === "community" ? "block" : "hidden lg:block"}`}>
              {/* Members Section */}
              <div>
                <HSectionHeader title="Members" actionLabel="Add new" />
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">
                  {members.map(member => (
                    <HMemberCard
                      key={member.id}
                      avatar={member.avatar}
                      name={member.name}
                      organization={member.organization}
                    />
                  ))}
                </div>
              </div>

              {/* Businesses Section */}
              <div>
                <HSectionHeader title="Businesses" actionLabel="Add new" />
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">
                  {businesses.map(business => (
                    <HBusinessCard
                      key={business.id}
                      logo={business.logo}
                      name={business.name}
                      description={business.description}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Announcements Section - Mobile only */}
          <div className={`${activeTab === "announcements" ? "block" : "hidden"} lg:hidden`}>
            <div className="mb-4">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Search announcements..."
                  className="w-full p-2 pl-10 bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-2"
                  style={{
                    "--tw-ring-color": `${Constants.HOST_EXPERIENCE_BASE_COLOR}50`,
                  }}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                <Search className="absolute left-3.5 top-2.5 text-gray-400 w-4 h-4" />
              </div>
            </div>

            {isLoadingAnnouncements ? (
              <ShimmerLoading />
            ) : (
              <>
                {filteredAnnouncements.length > 0 ? (
                  <div className="space-y-2">
                    {filteredAnnouncements.map(announcement => (
                      <div
                        key={announcement.id}
                        className="bg-white rounded-xl shadow-sm p-3 border border-gray-100 w-full flex items-center"
                      >
                        {announcement.image ? (
                          <div className="mr-3 overflow-hidden rounded-md flex-shrink-0">
                            <img src={announcement.image} alt="" className="w-16 h-16 object-cover" />
                          </div>
                        ) : (
                          <div
                            className="w-16 h-16 mr-3 rounded-md flex items-center justify-center flex-shrink-0"
                            style={{
                              backgroundColor: `${Constants.HOST_EXPERIENCE_BASE_COLOR}20`,
                            }}
                          >
                            <Megaphone
                              className="w-8 h-8"
                              style={{
                                color: Constants.HOST_EXPERIENCE_BASE_COLOR,
                              }}
                            />
                          </div>
                        )}

                        <div className="flex-1 min-w-0">
                          <div className="flex justify-between items-start mb-1">
                            <div
                              className="font-semibold text-sm truncate"
                              style={{
                                color: Constants.HOST_EXPERIENCE_BASE_COLOR,
                              }}
                            >
                              {announcement.title}
                            </div>
                            <div className="flex items-center ml-2">
                              <button
                                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                onClick={() => handleDeleteAnnouncement(announcement)}
                                title="Delete announcement"
                              >
                                <Trash2 className="w-3.5 h-3.5 text-gray-400 hover:text-red-500" />
                              </button>
                              <button
                                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                                onClick={() => handleEditAnnouncement(announcement)}
                                title="Edit announcement"
                              >
                                <Edit className="w-3.5 h-3.5 text-gray-400 hover:text-blue-500" />
                              </button>
                            </div>
                          </div>
                          <div className="text-xs text-gray-600 line-clamp-2 mb-2">{announcement.message}</div>
                          <div className="flex items-center justify-between text-xs text-gray-500">
                            <div className="flex items-center gap-1">
                              <Calendar className="w-3 h-3" />
                              <span>Created: {formatDate(announcement.createdAt)}</span>
                            </div>
                            <div>Scheduled: {formatDateTime(announcement.datetimeToSend)}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="bg-white rounded-xl shadow-sm p-6 text-center w-full">
                    <div className="text-gray-500 mb-2">No announcements found</div>
                    <button
                      className="text-sm font-medium"
                      style={{ color: Constants.HOST_EXPERIENCE_BASE_COLOR }}
                      onClick={() => setShowAnnouncementModal(true)}
                    >
                      Create your first announcement
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modals */}
      <HCreateEventModal isOpen={showEventModal} onClose={() => setShowEventModal(false)} initialType="event" />

      <HCreateAnnouncementModal
        isOpen={showAnnouncementModal}
        onClose={() => setShowAnnouncementModal(false)}
        onSave={handleAddAnnouncement}
      />

      <HEditAnnouncementModal
        isOpen={showEditAnnouncementModal}
        onClose={() => setShowEditAnnouncementModal(false)}
        announcement={announcementToEdit}
        onSave={handleEditSave}
      />

      {/* Confirm Delete Modal */}
      {showConfirmDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-sm w-full p-5">
            <div className="mb-4">
              <h3 className="text-lg font-semibold">Confirm Delete</h3>
            </div>
            <p className="text-gray-600 mb-4">
              Are you sure you want to delete "{announcementToDelete?.title}"? This action cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <HActionButton
                label="Cancel"
                variant="outline"
                size="medium"
                onClick={() => setShowConfirmDeleteModal(false)}
              />
              <HActionButton
                label="Delete"
                variant="primary"
                color="danger"
                size="medium"
                onClick={handleConfirmDelete}
              />
            </div>
          </div>
        </div>
      )}
    </HPageContainer>
  );
};

export default HostCommunity;
